import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'tr',
  months: [
    'Ocak',
    'Şubat',
    'Mart',
    'Nisan',
    'Mayıs',
    'Haziran',
    'Temmuz',
    'Ağustos',
    'Eylül',
    'Ekim',
    'Kasım',
    'Aralık',
  ],
  monthsShort: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
  weekdays: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
  weekdaysMin: ['P', 'P', 'S', 'Ç', 'P', 'C', 'C'],
  weekdaysShort: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'DD.MM.YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'D MMMM YYYY dddd, HH:mm',
    'LLLL-Y': 'D MMMM dddd, HH:mm',
    l: 'DD.MM.YYYY',
    'l-Y': 'DD.MM',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY, H:mm',
    'lll-Y': 'D MMM, H:mm',
    llll: 'D MMM YYYY, ddd H:mm',
    'llll-Y': 'D MMM ddd, H:mm',
    'll-Y+w': 'D MMM ddd',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'öö', pm: 'ös', AM: 'ÖÖ', PM: 'ÖS' },
  past: {
    y: { one: '%s yıl önce', other: '%s yıl önce' },
    M: { one: '%s ay önce', other: '%s ay önce' },
    w: { one: '%s hf. önce', other: '%s hf. önce' },
    d: { one: '%s gün önce', other: '%s gün önce' },
    h: { one: '%s sa. önce', other: '%s sa. önce' },
    m: { one: '%s dk. önce', other: '%s dk. önce' },
    s: { one: '%s sn. önce', other: '%s sn. önce' },
  },
  future: {
    y: { one: '%s yıl sonra', other: '%s yıl sonra' },
    M: { one: '%s ay sonra', other: '%s ay sonra' },
    w: { one: '%s hf. sonra', other: '%s hf. sonra' },
    d: { one: '%s gün sonra', other: '%s gün sonra' },
    h: { one: '%s sa. sonra', other: '%s sa. sonra' },
    m: { one: '%s dk. sonra', other: '%s dk. sonra' },
    s: { one: '%s sn. sonra', other: '%s sn. sonra' },
  },
  pastLong: {
    y: { one: '%s yıl önce', other: '%s yıl önce' },
    M: { one: '%s ay önce', other: '%s ay önce' },
    w: { one: '%s hafta önce', other: '%s hafta önce' },
    d: { one: '%s gün önce', other: '%s gün önce' },
    h: { one: '%s saat önce', other: '%s saat önce' },
    m: { one: '%s dakika önce', other: '%s dakika önce' },
    s: { one: '%s saniye önce', other: '%s saniye önce' },
  },
  futureLong: {
    y: { one: '%s yıl sonra', other: '%s yıl sonra' },
    M: { one: '%s ay sonra', other: '%s ay sonra' },
    w: { one: '%s hafta sonra', other: '%s hafta sonra' },
    d: { one: '%s gün sonra', other: '%s gün sonra' },
    h: { one: '%s saat sonra', other: '%s saat sonra' },
    m: { one: '%s dakika sonra', other: '%s dakika sonra' },
    s: { one: '%s saniye sonra', other: '%s saniye sonra' },
  },
  abbr: {
    y: { one: '%syıl', other: '%syıl' },
    M: { one: '%sa', other: '%sa' },
    w: { one: '%sh', other: '%sh' },
    d: { one: '%sg', other: '%sg' },
    h: { one: '%ss', other: '%ss' },
    m: { one: '%sdk', other: '%sdk' },
    s: { one: '%ssn', other: '%ssn' },
  },
  full: {
    y: { one: '%s yıl', other: '%s yıl' },
    M: { one: '%s ay', other: '%s ay' },
    w: { one: '%s hafta', other: '%s hafta' },
    d: { one: '%s gün', other: '%s gün' },
    h: { one: '%s saat', other: '%s saat' },
    m: { one: '%s dakika', other: '%s dakika' },
    s: { one: '%s saniye', other: '%s saniye' },
  },
  justNow: 'Tam şimdi',
  yesterday: 'Dün',
  today: 'Bugün',
  tomorrow: 'Yarın',
  weekStart: 1,
  timeRange: '%$1s - %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D MMMM YYYY', end: 'D MMMM YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM YYYY', end: 'D MMM YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'D MMM YYYY ddd', end: 'D MMM YYYY ddd' },
    'Y-1': { start: 'D MMM YYYY ddd', end: 'D MMM YYYY ddd' },
    M: { start: 'D MMM ddd', end: 'D MMM ddd' },
    D: { start: 'D MMM ddd', end: 'D MMM ddd' },
    yt: { start: 'D MMM YYYY HH:mm', end: 'D MMM YYYY HH:mm' },
    mt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    dt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D MMM YYYY HH:mm', end: 'D MMM YYYY HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'tr';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}.`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'öö' : 'ÖÖ';
    } else {
      return isLowerCase ? 'ös' : 'ÖS';
    }
  },
};
